import type { Campaign } from './schema';

export function flattenCampaigns(campaigns: Campaign[]): FlatCampaign[] {
  return campaigns
    .filter(campaign => campaign.campaign_schedules && Array.isArray(campaign.campaign_schedules))
    .flatMap((campaign) =>
      campaign.campaign_schedules.map((schedule) => ({
        id: `${campaign.id}-${schedule.id}`,
        campaign_id: campaign.id,
        schedule_id: schedule.id,
        title: `${campaign.id} - ${campaign.title}`,
        inbox_name: campaign.inbox.name,
        channel_type: campaign.inbox.channel_type,
        audience: campaign.audience,
        message: campaign.message,
        scheduled_at: schedule.scheduled_at,
        campaign_status: schedule.campaign_status,
        campaign_status_label: schedule.campaign_status_label,
        filter_data: JSON.stringify(schedule.filter_data || {}),
        template_params: JSON.stringify(schedule.template_params || {}),
        campaign_status_values: campaign.campaign_status_values || [],

        // ✅ Campos de status adicionais
        status: schedule.campaign_status,
        status_data: schedule.status_data || null,
        progress_percentage: schedule.progress_percentage || 0,
        total_items: schedule.total_items || 0,
        items_processed: schedule.items_processed || 0,
        items_sent: schedule.items_sent || 0, // ✅ ADICIONAR
        items_failed: schedule.items_failed || 0, // ✅ ADICIONAR
        status_message: schedule.status_message || '',
        
        // ✅ NOVO: STATISTICS (coluna dedicada)
        statistics: schedule.statistics || null,

        // Contadores da feature HOLD (entregas seguradas por atendimento ativo)
        hold_stats: schedule.hold_stats || null,

        // ✅ Sender da campaign
        sender_id: campaign.sender_id,
        sender_name: campaign.sender_name,

        // Tipo da campanha
        campaign_type: campaign.campaign_type,
      }))
    )
    .sort((a, b) => new Date(a.scheduled_at).getTime() - new Date(b.scheduled_at).getTime());
}

export interface FlatCampaign {
  id: string;
  campaign_id: number;
  schedule_id: number;
  title: string;
  inbox_name: string;
  channel_type: string;
  audience: string[];
  message: string;
  scheduled_at: string;
  campaign_status: string;
  campaign_status_label?: string;
  filter_data: string;
  template_params: string;
  campaign_status_values?: string[];

  // ✅ Campos de status adicionais
  status: string;
  status_data?: any;
  progress_percentage?: number;
  total_items?: number;
  items_processed?: number;
  items_sent?: number; // ✅ ADICIONAR
  items_failed?: number; // ✅ ADICIONAR
  status_message?: string;
  
  // ✅ NOVO: STATISTICS
  statistics?: {
    total_from_query?: number;
    duplicates_removed?: number;
    blacklisted_count?: number;
    valid_for_sending?: number;
  } | null;

  // Contadores da feature HOLD (entregas seguradas por atendimento ativo)
  hold_stats?: {
    held?: number;
    released?: number;
    expired?: number;
  } | null;

  // ✅ Sender da campaign
  sender_id: number | null;
  sender_name: string | null;

  // Tipo da campanha
  campaign_type: string;
}